import { useEffect } from 'react';

type Props = {
  name: string;
  eventHandler: (event: Event) => void;
};

export const useEventHandler = ({ name, eventHandler }: Props) => {
  useEffect(() => {
    window.addEventListener(name, eventHandler);
    return () => {
      window.removeEventListener(name, eventHandler);
    };
  }, [name, eventHandler]);
};

export const emit = (eventName: string) => {
  window.dispatchEvent(new CustomEvent(eventName, { detail: {} }));
};
